import "./advertDetail.css";
import { Link } from "react-router-dom";
import {
  collection,
  query,
  orderBy,
  onSnapshot,
  updateDoc,
  doc,
} from "firebase/firestore";
import { db } from "../../firebase";
import { useEffect, useState } from "react";

export default function AdvertDetail() {
  const [oneTask, setOneTask] = useState([]);
  const [newPost, setNewPost] = useState("");

  const handleSubmit = async (id, marka) => {
    const postRef = doc(db, "ilanlar", id);
    const newFields = { marka: marka };
    await updateDoc(postRef, newFields);
  };
  //Fetch Data When Page Loads
  useEffect(() => {
    const taskColRef = query(
      collection(db, "ilanlar"),
      orderBy("created", "desc")
    );
    onSnapshot(taskColRef, (snapshot) => {
      setOneTask(
        snapshot.docs.map((doc) => ({
          id: doc.id,
          data: doc.data(),
        }))
      );
    });
  }, []);

  return (
    <div className="user">
      <div className="userTitleContainer">
        <h1 className="userTitle">İlan Düzenle</h1>
        <Link to="/advertList">
          <button className="userAddButton">Geri Gel</button>
        </Link>
      </div>
      <div className="userContainer">
        <div className="userShow">
          <span className="userShowTitle">İlan Detayları</span>

          {oneTask.map((task) => (
            <div className="userShowBottom">
              <span className="userShowInfoTitle" key={task.uid}>
                İlan ID: {task.id}
              </span>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Marka: {task.data.marka}
                </span>
              </div>

              <span className="userShowTitle" key={task.uid}>
                Katılım Şartları: {task.data.participate}
              </span>
              <div className="userShowInfo">
                <span className="userShowInfoTitle">Profil Durumu:</span>
              </div>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Minimum Takipçi Sayısı: {task.data.minFollowers}
                </span>
              </div>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Cinsiyet: {task.data.gender}
                </span>
              </div>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Lokasyon: {task.data.address}
                </span>
              </div>
              <span className="userShowTitle" key={task.uid}>
                Ödeme: {task.data.minPay}{" "}
              </span>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Ürün Gönderimi: {task.data.product}
                </span>
              </div>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Ücret Aralığı: {task.data.minPay} - {task.data.maxPay}
                </span>
              </div>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Metin Kısmı: {task.data.par}
                </span>
              </div>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Notlar: {task.data.notes}
                </span>
              </div>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Üst Metin: {task.data.title}
                </span>
              </div>
              <div className="userShowInfo">
                <span className="userShowInfoTitle" key={task.uid}>
                  Alt Metin Kısmı: {task.data.par}
                </span>
              </div>
            </div>
          ))}
        </div>
        <div className="userUpdate">
          <span className="userUpdateTitle">Düzenle</span>
          <div className="userUpdateForm">
            <div className="userUpdateLeft">
              <div className="userUpdateItem">
                <label>Üst Metin</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Marka</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Minimum Takipçi Sayısı</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Cinsiyet</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Lokasyon</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Ürün Gönderimi</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Ücret Aralığı</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Ana Metin Kısmı</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Notlar</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Üst Metin Kısmı</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
              <div className="userUpdateItem">
                <label>Alt Metin Kısmı</label>
                <input
                  type="text"
                  placeholder=""
                  className="userUpdateInput"
                  onChange={(event) => {
                    setNewPost(event.target.value);
                  }}
                />
              </div>
            </div>
            <div className="userUpdateRight">
              <button className="userUpdateButton">Güncelle</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
